<template>
    <li class="omni-sidebar-item">
        <template v-if="item.to">
            <RouterLink
                :to="item.to"
                @click="activeItem = item"
                class="omni-sidebar-link"
            >
                <span class="omni-sidebar-label">
                    {{ item.title }}
                </span>
            </RouterLink>
        </template>

        <template v-else>
            <span class="omni-sidebar-heading">
                {{ item.title }}
            </span>
        </template>

        <ul v-if="item.children">
            <OmniSidebarItem
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
            />
        </ul>
    </li>
</template>

<style lang="scss">
.omni-sidebar-item {
    margin-bottom: 1rem;

    ul {
        list-style: none;
        padding: 0 0 0 1rem;
        margin-top: 1rem;
    }
    
    .omni-sidebar-heading {
        font-size: 1rem;
        font-weight: 600;
        color: #555;
    }

    .omni-sidebar-link {
        color: #333;
        font-weight: 700;
        &.router-link-exact-active {
            padding: .25rem .5rem;
            border-radius: .5rem;
            color: #fff;
            background: rgba(0,0,0,.35);
        }
    }
}
</style>

<script>
export default {
    name: "OmniSidebarItem",

    props: {
        item: {
            type: Object,
            required: true,
        },
    },
}
</script>